import Vue from 'vue'
import VueMaterial from 'vue-material'
import VueRouter from 'vue-router'
// import VuePageTitle from 'vue-page-title'
import VueHead from 'vue-head'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default-dark.css'
import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'
import App from './App.vue'
import Home from './components/content/Home.vue'
import About from './components/content/About.vue'
import Projects from './components/content/Projects.vue'
import Publications from './components/content/Publications.vue'
import Contact from './components/content/Contact.vue'
import RandomStuff from './components/content/RandomStuff.vue'
import PageNotFound from './components/content/404.vue'
import i18n from './i18n'
import VueAnalytics from 'vue-analytics'

Vue.config.productionTip = true
Vue.use(VueMaterial)
Vue.use(VueHead)
Vue.use(VueRouter)

const routes = [
  { path: '/', name: 'Home', component: Home, meta: { title: "Home" } },
  { path: '/about', name: 'About', component: About, meta: { title: "About" } },
  { path: '/projects', name: 'Projects', component: Projects, meta: { title: "Projects" } },
  { path: '/publications', name: 'Publications', component: Publications, meta: { title: "Publications" } },
  { path: '/contact', name: 'Contact', component: Contact, meta: { title: "Contact" } },
  { path: '/randomstuff', name: 'RandomStuff', component: RandomStuff, meta: { title: "Random Stuff" } },
  { path: "*", component: PageNotFound }
];

const router = new VueRouter({
  routes
});

router.beforeEach((to, from, next) => {
  document.title = "Fabrício Ceschin - " + i18n.t(to.meta.title) // meta.title is keypath of locale messages
  next()
})

// Vue.use(VuePageTitle, { router })

// Configuration VueAnalytics
Vue.use(VueAnalytics, {
  // id: 'G-YHH41QP30F', // github
  id: 'G-DC206M97N3', // DInf
  router
});

// new Vue({
//   render: h => h(App),
// }).$mount('#app')
new Vue({
  el: '#app',
  router,
  i18n,
  render: h => h(App)
});
